import React, { useState, Children, Component } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon, CheckCircleIcon, Star, PlusIcon, MinusIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
// Unique SVG illustrations for each location
function TorontoIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-612">
      {/* CN Tower */}
      <rect x="188" y="30" width="8" height="20" rx="2" fill="white" fillOpacity="0.3" data-id="element-613" />
      <rect x="190" y="10" width="4" height="25" fill="white" fillOpacity="0.4" data-id="element-614" />
      <path d="M180 140 L192 50 L200 50 L212 140Z" fill="white" fillOpacity="0.2" stroke="white" strokeOpacity="0.4" strokeWidth="1.5" data-id="element-615" />
      <ellipse cx="196" cy="110" rx="18" ry="8" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.4" strokeWidth="1.5" data-id="element-616" />
      <rect x="192" y="140" width="8" height="130" fill="white" fillOpacity="0.2" stroke="white" strokeOpacity="0.3" strokeWidth="1" data-id="element-617" />
      {/* Skyline buildings */}
      <rect x="60" y="180" width="35" height="90" rx="2" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.25" strokeWidth="1" data-id="element-618" />
      <rect x="100" y="160" width="30" height="110" rx="2" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-619" />
      <rect x="135" y="190" width="25" height="80" rx="2" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-620" />
      <rect x="230" y="170" width="28" height="100" rx="2" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-621" />
      <rect x="265" y="150" width="35" height="120" rx="2" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.25" strokeWidth="1" data-id="element-622" />
      <rect x="305" y="185" width="30" height="85" rx="2" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-623" />
      {/* Ground line */}
      <line x1="30" y1="270" x2="370" y2="270" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" data-id="element-624" />
      {/* Lake Ontario waves */}
      <path d="M30 290 Q80 282 130 290 Q180 298 230 290 Q280 282 330 290 Q355 295 370 290" stroke="white" strokeOpacity="0.15" strokeWidth="1.5" fill="none" data-id="element-625" />
      <path d="M30 305 Q80 297 130 305 Q180 313 230 305 Q280 297 330 305 Q355 310 370 305" stroke="white" strokeOpacity="0.1" strokeWidth="1" fill="none" data-id="element-626" />
    </svg>;
}
function MississaugaIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-627">
      {/* Absolute Towers (Marilyn Monroe Towers) */}
      <path d="M140 270 L145 80 Q155 75 160 80 L165 270Z" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.35" strokeWidth="1.5" data-id="element-628" />
      <path d="M145 120 Q152 115 160 120" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-629" />
      <path d="M144 160 Q152 155 161 160" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-630" />
      <path d="M143 200 Q152 195 162 200" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-631" />
      <path d="M142 240 Q152 235 163 240" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-632" />
      {/* Second tower with twist */}
      <path d="M200 270 L208 60 Q218 55 225 60 L230 270Z" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" data-id="element-633" />
      <path d="M207 100 Q216 95 226 100" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-634" />
      <path d="M206 140 Q216 135 227 140" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-635" />
      <path d="M205 180 Q216 175 228 180" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-636" />
      <path d="M204 220 Q216 215 229 220" stroke="white" strokeOpacity="0.2" strokeWidth="0.8" data-id="element-637" />
      {/* Surrounding buildings */}
      <rect x="80" y="200" width="30" height="70" rx="2" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-638" />
      <rect x="270" y="190" width="35" height="80" rx="2" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-639" />
      <rect x="315" y="210" width="25" height="60" rx="2" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-640" />
      {/* Ground */}
      <line x1="50" y1="270" x2="360" y2="270" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" data-id="element-641" />
      {/* Credit Valley path */}
      <path d="M50 300 Q120 285 200 295 Q280 305 360 290" stroke="white" strokeOpacity="0.12" strokeWidth="1.5" fill="none" data-id="element-642" />
    </svg>;
}
function BramptonIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-643">
      {/* Flower City - Large decorative flower */}
      <circle cx="200" cy="130" r="18" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.35" strokeWidth="1.5" data-id="element-644" />
      <ellipse cx="200" cy="100" rx="14" ry="20" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.25" strokeWidth="1" data-id="element-645" />
      <ellipse cx="200" cy="100" rx="14" ry="20" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.25" strokeWidth="1" transform="rotate(60 200 130)" data-id="element-646" />
      <ellipse cx="200" cy="100" rx="14" ry="20" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.25" strokeWidth="1" transform="rotate(120 200 130)" data-id="element-647" />
      <ellipse cx="200" cy="100" rx="14" ry="20" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.25" strokeWidth="1" transform="rotate(180 200 130)" data-id="element-648" />
      <ellipse cx="200" cy="100" rx="14" ry="20" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.25" strokeWidth="1" transform="rotate(240 200 130)" data-id="element-649" />
      <ellipse cx="200" cy="100" rx="14" ry="20" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.25" strokeWidth="1" transform="rotate(300 200 130)" data-id="element-650" />
      {/* Stem */}
      <path d="M200 155 L200 260" stroke="white" strokeOpacity="0.25" strokeWidth="2" data-id="element-651" />
      <path d="M200 200 Q230 185 240 195" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" fill="none" data-id="element-652" />
      <path d="M200 220 Q170 210 160 218" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" fill="none" data-id="element-653" />
      {/* Houses representing suburban community */}
      <path d="M70 270 L70 240 L90 225 L110 240 L110 270Z" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-654" />
      <path d="M290 270 L290 240 L310 225 L330 240 L330 270Z" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-655" />
      <path d="M130 270 L130 248 L145 238 L160 248 L160 270Z" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-656" />
      <path d="M240 270 L240 248 L255 238 L270 248 L270 270Z" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-657" />
      {/* Ground */}
      <line x1="40" y1="270" x2="370" y2="270" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" data-id="element-658" />
      {/* Garden path */}
      <path d="M40 295 Q120 285 200 290 Q280 295 370 288" stroke="white" strokeOpacity="0.1" strokeWidth="1" fill="none" data-id="element-659" />
    </svg>;
}
function MarkhamIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-660">
      {/* Markham Civic Centre inspired modern building */}
      <rect x="150" y="100" width="100" height="170" rx="3" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" data-id="element-661" />
      <rect x="160" y="110" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-662" />
      <rect x="185" y="110" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-663" />
      <rect x="210" y="110" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-664" />
      <rect x="160" y="138" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-665" />
      <rect x="185" y="138" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-666" />
      <rect x="210" y="138" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-667" />
      <rect x="160" y="166" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-668" />
      <rect x="185" y="166" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-669" />
      <rect x="210" y="166" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-670" />
      <rect x="160" y="194" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-671" />
      <rect x="185" y="194" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-672" />
      <rect x="210" y="194" width="18" height="18" rx="1" fill="white" fillOpacity="0.08" data-id="element-673" />
      {/* Tech/innovation symbol - circuit lines */}
      <circle cx="85" cy="160" r="6" fill="white" fillOpacity="0.2" stroke="white" strokeOpacity="0.3" strokeWidth="1" data-id="element-674" />
      <line x1="91" y1="160" x2="150" y2="160" stroke="white" strokeOpacity="0.15" strokeWidth="1" strokeDasharray="4 3" data-id="element-675" />
      <circle cx="315" cy="180" r="6" fill="white" fillOpacity="0.2" stroke="white" strokeOpacity="0.3" strokeWidth="1" data-id="element-676" />
      <line x1="250" y1="180" x2="309" y2="180" stroke="white" strokeOpacity="0.15" strokeWidth="1" strokeDasharray="4 3" data-id="element-677" />
      <circle cx="85" cy="210" r="4" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.25" strokeWidth="1" data-id="element-678" />
      <line x1="89" y1="210" x2="150" y2="210" stroke="white" strokeOpacity="0.1" strokeWidth="1" strokeDasharray="4 3" data-id="element-679" />
      {/* Smaller buildings */}
      <rect x="70" y="220" width="40" height="50" rx="2" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-680" />
      <rect x="290" y="210" width="45" height="60" rx="2" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-681" />
      {/* Ground */}
      <line x1="40" y1="270" x2="370" y2="270" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" data-id="element-682" />
      {/* Trees */}
      <circle cx="55" cy="255" r="12" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-683" />
      <circle cx="350" cy="255" r="12" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-684" />
    </svg>;
}
function VaughanIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-685">
      {/* Canada's Wonderland roller coaster silhouette */}
      <path d="M60 250 Q80 100 120 180 Q140 220 160 140 Q180 80 210 160 Q230 210 260 120 Q290 50 310 170 Q325 230 350 200" stroke="white" strokeOpacity="0.3" strokeWidth="2" fill="none" data-id="element-686" />
      {/* Support structures */}
      <line x1="90" y1="145" x2="90" y2="270" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-687" />
      <line x1="140" y1="180" x2="140" y2="270" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-688" />
      <line x1="190" y1="120" x2="190" y2="270" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-689" />
      <line x1="240" y1="165" x2="240" y2="270" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-690" />
      <line x1="290" y1="85" x2="290" y2="270" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-691" />
      <line x1="330" y1="195" x2="330" y2="270" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-692" />
      {/* Vaughan Metropolitan Centre towers */}
      <rect x="100" y="200" width="22" height="70" rx="2" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-693" />
      <rect x="270" y="195" width="25" height="75" rx="2" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-694" />
      {/* Ground */}
      <line x1="40" y1="270" x2="370" y2="270" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" data-id="element-695" />
      {/* Decorative stars */}
      <circle cx="295" cy="45" r="3" fill="white" fillOpacity="0.3" data-id="element-696" />
      <circle cx="180" cy="70" r="2" fill="white" fillOpacity="0.2" data-id="element-697" />
      <circle cx="320" cy="80" r="2" fill="white" fillOpacity="0.15" data-id="element-698" />
    </svg>;
}
function RichmondHillIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-699">
      {/* Rolling hills */}
      <path d="M0 250 Q60 210 120 230 Q180 250 240 220 Q300 190 360 210 L400 220 L400 350 L0 350Z" fill="white" fillOpacity="0.06" data-id="element-700" />
      <path d="M0 250 Q60 210 120 230 Q180 250 240 220 Q300 190 360 210 L400 220" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" fill="none" data-id="element-701" />
      {/* Houses on hills */}
      <path d="M90 225 L90 205 L105 193 L120 205 L120 225Z" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.25" strokeWidth="1" data-id="element-702" />
      <rect x="97" y="210" width="8" height="15" fill="white" fillOpacity="0.08" data-id="element-703" />
      <path d="M200 218 L200 195 L218 180 L236 195 L236 218Z" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.3" strokeWidth="1" data-id="element-704" />
      <rect x="210" y="200" width="10" height="18" fill="white" fillOpacity="0.1" data-id="element-705" />
      <path d="M310 208 L310 188 L325 176 L340 188 L340 208Z" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-706" />
      <rect x="318" y="192" width="8" height="16" fill="white" fillOpacity="0.06" data-id="element-707" />
      {/* Trees */}
      <circle cx="60" cy="230" r="15" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-708" />
      <circle cx="160" cy="235" r="12" fill="white" fillOpacity="0.05" stroke="white" strokeOpacity="0.1" strokeWidth="1" data-id="element-709" />
      <circle cx="270" cy="215" r="14" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-710" />
      <circle cx="365" cy="205" r="10" fill="white" fillOpacity="0.05" stroke="white" strokeOpacity="0.1" strokeWidth="1" data-id="element-711" />
      {/* Sun/moon */}
      <circle cx="320" cy="80" r="30" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.15" strokeWidth="1.5" data-id="element-712" />
      {/* Birds */}
      <path d="M100 100 Q105 95 110 100 Q115 95 120 100" stroke="white" strokeOpacity="0.2" strokeWidth="1" fill="none" data-id="element-713" />
      <path d="M150 80 Q154 76 158 80 Q162 76 166 80" stroke="white" strokeOpacity="0.15" strokeWidth="1" fill="none" data-id="element-714" />
    </svg>;
}
function OakvilleIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-715">
      {/* Lighthouse */}
      <path d="M175 270 L180 140 L200 130 L220 140 L225 270Z" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" data-id="element-716" />
      <rect x="185" y="120" width="30" height="15" rx="2" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.35" strokeWidth="1" data-id="element-717" />
      <path d="M185 120 L200 105 L215 120" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.3" strokeWidth="1" data-id="element-718" />
      {/* Light beam */}
      <path d="M215 115 L310 80 L300 95Z" fill="white" fillOpacity="0.06" data-id="element-719" />
      <path d="M185 115 L90 80 L100 95Z" fill="white" fillOpacity="0.06" data-id="element-720" />
      {/* Sailboat */}
      <path d="M310 200 L310 160 L340 195Z" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.25" strokeWidth="1" data-id="element-721" />
      <path d="M310 200 L310 165 L285 195Z" fill="white" fillOpacity="0.08" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-722" />
      <path d="M280 200 L345 200" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" data-id="element-723" />
      <path d="M275 205 Q310 212 350 205" stroke="white" strokeOpacity="0.15" strokeWidth="1" fill="none" data-id="element-724" />
      {/* Waterfront */}
      <line x1="40" y1="270" x2="170" y2="270" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" data-id="element-725" />
      <line x1="230" y1="270" x2="370" y2="270" stroke="white" strokeOpacity="0.15" strokeWidth="1" data-id="element-726" />
      {/* Lake waves */}
      <path d="M40 285 Q90 278 140 285 Q190 292 240 285 Q290 278 340 285 Q360 288 370 285" stroke="white" strokeOpacity="0.12" strokeWidth="1.5" fill="none" data-id="element-727" />
      <path d="M40 300 Q90 294 140 300 Q190 306 240 300 Q290 294 340 300" stroke="white" strokeOpacity="0.08" strokeWidth="1" fill="none" data-id="element-728" />
      {/* Small sailboat in distance */}
      <path d="M90 240 L90 225 L105 237Z" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.1" strokeWidth="0.8" data-id="element-729" />
    </svg>;
}
function BurlingtonIllustration() {
  return <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-730">
      {/* Burlington Skyway Bridge */}
      <path d="M40 200 Q120 120 200 150 Q280 180 360 130" stroke="white" strokeOpacity="0.3" strokeWidth="2.5" fill="none" data-id="element-731" />
      {/* Bridge cables */}
      <line x1="100" y1="155" x2="100" y2="250" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-732" />
      <line x1="150" y1="140" x2="150" y2="250" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-733" />
      <line x1="200" y1="150" x2="200" y2="250" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-734" />
      <line x1="250" y1="160" x2="250" y2="250" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-735" />
      <line x1="300" y1="150" x2="300" y2="250" stroke="white" strokeOpacity="0.12" strokeWidth="1" data-id="element-736" />
      {/* Pier/dock */}
      <rect x="60" y="250" width="120" height="8" rx="1" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.2" strokeWidth="1" data-id="element-737" />
      <line x1="80" y1="258" x2="80" y2="280" stroke="white" strokeOpacity="0.15" strokeWidth="2" data-id="element-738" />
      <line x1="120" y1="258" x2="120" y2="280" stroke="white" strokeOpacity="0.15" strokeWidth="2" data-id="element-739" />
      <line x1="160" y1="258" x2="160" y2="280" stroke="white" strokeOpacity="0.15" strokeWidth="2" data-id="element-740" />
      {/* Escarpment/hills in background */}
      <path d="M0 220 Q50 190 100 200 Q150 210 200 195 Q250 180 300 190 Q350 200 400 185" stroke="white" strokeOpacity="0.1" strokeWidth="1" fill="none" data-id="element-741" />
      {/* Waterfront */}
      <path d="M40 290 Q100 282 160 290 Q220 298 280 290 Q340 282 370 288" stroke="white" strokeOpacity="0.12" strokeWidth="1.5" fill="none" data-id="element-742" />
      <path d="M40 305 Q100 298 160 305 Q220 312 280 305 Q340 298 370 303" stroke="white" strokeOpacity="0.08" strokeWidth="1" fill="none" data-id="element-743" />
      {/* Trees on shore */}
      <circle cx="280" cy="240" r="12" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.1" strokeWidth="1" data-id="element-744" />
      <circle cx="320" cy="235" r="15" fill="white" fillOpacity="0.06" stroke="white" strokeOpacity="0.1" strokeWidth="1" data-id="element-745" />
      <circle cx="355" cy="240" r="10" fill="white" fillOpacity="0.05" stroke="white" strokeOpacity="0.08" strokeWidth="1" data-id="element-746" />
    </svg>;
}
const locationIllustrations: Record<string, React.FC> = {
  toronto: TorontoIllustration,
  mississauga: MississaugaIllustration,
  brampton: BramptonIllustration,
  markham: MarkhamIllustration,
  vaughan: VaughanIllustration,
  'richmond-hill': RichmondHillIllustration,
  oakville: OakvilleIllustration,
  burlington: BurlingtonIllustration
};
interface Review {
  id: number;
  name: string;
  timeAgo: string;
  text: string;
}
interface FAQ {
  question: string;
  answer: string;
}
interface LocationData {
  slug: string;
  name: string;
  heroDescription: string;
  whyChooseDescription: string;
  reviews: Review[];
  faqs: FAQ[];
}
const locationsData: LocationData[] = [{
  slug: 'toronto',
  name: 'Toronto',
  heroDescription: "Unlock the power of your Toronto home's equity. We provide fast, flexible, and equity-based mortgage solutions tailored for homeowners in Canada's largest real estate market.",
  whyChooseDescription: 'As a leading private mortgage lender in Toronto, we understand the unique dynamics of the local real estate market. Our equity-based approach means we focus on the value of your Toronto property, not your credit score or income history.',
  reviews: [{
    id: 1,
    name: 'David M.',
    timeAgo: '2 weeks ago',
    text: 'EquityRich made getting a second mortgage on my Toronto condo incredibly easy. The funds were in my account within 48 hours. Highly recommend their fast service!'
  }, {
    id: 2,
    name: 'Sarah T.',
    timeAgo: '1 month ago',
    text: "After my bank turned me down due to being self-employed, EquityRich looked at my home's equity instead. They saved my renovation project in North York."
  }, {
    id: 3,
    name: 'James L.',
    timeAgo: '3 months ago',
    text: 'The debt consolidation mortgage I got through EquityRich helped me pay off high-interest credit cards. The process was transparent and the Toronto team was fantastic.'
  }],
  faqs: [{
    question: 'What types of mortgages are available in Toronto?',
    answer: 'We offer a wide range of equity-based solutions in Toronto, including private mortgages, second mortgages, HELOCs, and debt consolidation mortgages.'
  }, {
    question: 'Do I need a credit check for a mortgage in Toronto?',
    answer: 'No, our lending decisions in Toronto are based entirely on the equity you have in your property, not your credit score or history.'
  }, {
    question: 'How quickly can I get funded in Toronto?',
    answer: 'Once approved, funds can be deposited into your account in as little as 48 hours. Our streamlined process avoids the lengthy delays typical of traditional Toronto banks.'
  }, {
    question: 'What is the maximum I can borrow against my Toronto home?',
    answer: "You can typically borrow up to 80% of your Toronto home's appraised value, minus any existing mortgages."
  }, {
    question: "Can I get a mortgage in Toronto if I'm self-employed?",
    answer: "Absolutely. We don't require traditional income verification, making our mortgages perfect for self-employed Toronto residents."
  }]
}, {
  slug: 'mississauga',
  name: 'Mississauga',
  heroDescription: 'Access the wealth tied up in your Mississauga property. Our equity-based lending solutions provide fast funding without the strict requirements of traditional banks.',
  whyChooseDescription: "Serving the growing Mississauga community, we offer flexible mortgage solutions that prioritize your home's equity over your financial past. Trust our local expertise to get you the funds you need.",
  reviews: [{
    id: 1,
    name: 'Priya S.',
    timeAgo: '3 weeks ago',
    text: "I needed quick funding for a business opportunity in Mississauga and EquityRich delivered. No income verification meant I didn't have to jump through hoops."
  }, {
    id: 2,
    name: 'Michael R.',
    timeAgo: '2 months ago',
    text: "The team at EquityRich understands the Mississauga market perfectly. They helped me secure a HELOC when my traditional bank wouldn't even look at my application."
  }, {
    id: 3,
    name: 'Elena K.',
    timeAgo: '4 months ago',
    text: "Consolidating my debt with a second mortgage on my Mississauga home was the best financial decision I've made. Thank you EquityRich for the smooth process."
  }],
  faqs: [{
    question: 'What types of mortgages are available in Mississauga?',
    answer: 'In Mississauga, we provide private mortgages, home equity loans, reverse mortgages, and specialized solutions like secondary suite mortgages.'
  }, {
    question: 'Do I need a credit check for a mortgage in Mississauga?',
    answer: 'No credit check is required. We focus on the equity built up in your Mississauga property to approve your mortgage.'
  }, {
    question: 'How quickly can I get funded in Mississauga?',
    answer: 'Our Mississauga clients often receive their funds within 48 hours of approval, thanks to our efficient, equity-focused underwriting process.'
  }, {
    question: 'What is the maximum I can borrow against my Mississauga home?',
    answer: "Homeowners in Mississauga can access up to 80% of their property's appraised value (Loan-to-Value ratio)."
  }, {
    question: "Can I get a mortgage in Mississauga if I'm self-employed?",
    answer: 'Yes, our no-income-verification mortgages are designed specifically to help self-employed individuals in Mississauga access their home equity.'
  }]
}, {
  slug: 'brampton',
  name: 'Brampton',
  heroDescription: "Leverage your Brampton home's equity for the financial flexibility you deserve. Fast approvals, no credit checks, and tailored solutions for your unique needs.",
  whyChooseDescription: "We are proud to serve the vibrant Brampton community with transparent, equity-based mortgage products. Whether you're consolidating debt or funding a renovation, our local knowledge ensures a smooth process.",
  reviews: [{
    id: 1,
    name: 'Raj P.',
    timeAgo: '1 week ago',
    text: 'EquityRich helped me get a second mortgage on my Brampton home to build a legal basement suite. The process was fast and the team was very knowledgeable.'
  }, {
    id: 2,
    name: 'Amanda W.',
    timeAgo: '1 month ago',
    text: 'I was stressed about my credit score, but EquityRich only cared about the equity in my Brampton property. They approved my loan in 24 hours!'
  }, {
    id: 3,
    name: 'Gurpreet S.',
    timeAgo: '3 months ago',
    text: "Excellent service from the EquityRich team. They explained all my options for accessing my Brampton home's equity clearly and without any pressure."
  }],
  faqs: [{
    question: 'What types of mortgages are available in Brampton?',
    answer: 'Brampton homeowners can access our full suite of products, including second mortgages, debt consolidation loans, and secondary suite financing.'
  }, {
    question: 'Do I need a credit check for a mortgage in Brampton?',
    answer: "No, we do not require credit checks for our Brampton clients. Your approval is based on your property's equity."
  }, {
    question: 'How quickly can I get funded in Brampton?',
    answer: 'We pride ourselves on speed. Brampton residents can typically access their funds within 48 hours of approval.'
  }, {
    question: 'What is the maximum I can borrow against my Brampton home?',
    answer: 'You can borrow up to 80% of the appraised value of your Brampton home, depending on existing mortgages.'
  }, {
    question: "Can I get a mortgage in Brampton if I'm self-employed?",
    answer: 'Yes! We offer no-income-verification mortgages that are perfect for self-employed business owners in Brampton.'
  }]
}, {
  slug: 'markham',
  name: 'Markham',
  heroDescription: 'Unlock the value of your Markham property with our flexible, equity-based mortgage solutions. No income verification, no credit checks—just fast access to your funds.',
  whyChooseDescription: "Markham's real estate market is strong, and we help you leverage that strength. Our equity-based lending approach provides Markham homeowners with the financial freedom they need, without traditional banking hurdles.",
  reviews: [{
    id: 1,
    name: 'Wei C.',
    timeAgo: '2 weeks ago',
    text: 'The process of getting a home equity loan in Markham was seamless with EquityRich. They valued my property fairly and funded the loan quickly.'
  }, {
    id: 2,
    name: 'Jennifer H.',
    timeAgo: '2 months ago',
    text: 'As a retiree in Markham, I wanted to access my equity without monthly payments. EquityRich set me up with a reverse mortgage that perfectly fit my needs.'
  }, {
    id: 3,
    name: 'Thomas B.',
    timeAgo: '5 months ago',
    text: 'I needed bridge financing for a new property purchase in Markham. EquityRich provided the short-term funds I needed without any hassle.'
  }],
  faqs: [{
    question: 'What types of mortgages are available in Markham?',
    answer: 'We offer private mortgages, HELOCs, bridge loans, and reverse mortgages tailored for Markham homeowners.'
  }, {
    question: 'Do I need a credit check for a mortgage in Markham?',
    answer: 'No credit check is needed. We look at the equity in your Markham home to determine your eligibility.'
  }, {
    question: 'How quickly can I get funded in Markham?',
    answer: 'Funding for Markham properties can be completed in as little as 48 hours after approval.'
  }, {
    question: 'What is the maximum I can borrow against my Markham home?',
    answer: "Markham homeowners can access up to 80% of their property's value through our equity-based lending programs."
  }, {
    question: "Can I get a mortgage in Markham if I'm self-employed?",
    answer: 'Absolutely. Our alternative lending solutions in Markham do not require traditional income verification.'
  }]
}, {
  slug: 'vaughan',
  name: 'Vaughan',
  heroDescription: "Turn your Vaughan home's equity into accessible cash. We provide fast, reliable private mortgage solutions tailored to the Vaughan real estate market.",
  whyChooseDescription: 'We understand the value of Vaughan real estate. Our equity-based lending model allows Vaughan homeowners to bypass strict bank requirements and access their wealth quickly and efficiently.',
  reviews: [{
    id: 1,
    name: 'Marco V.',
    timeAgo: '3 weeks ago',
    text: 'EquityRich provided a second mortgage for my Vaughan home when I needed to consolidate business debt. Fast, professional, and no credit check!'
  }, {
    id: 2,
    name: 'Lisa M.',
    timeAgo: '1 month ago',
    text: 'The team was incredibly helpful in explaining how a HELOC worked for my property in Vaughan. I now have the flexible funding I need for renovations.'
  }, {
    id: 3,
    name: 'Anthony D.',
    timeAgo: '4 months ago',
    text: 'I highly recommend EquityRich to anyone in Vaughan looking for alternative mortgage lenders. They focus on equity, which made all the difference for me.'
  }],
  faqs: [{
    question: 'What types of mortgages are available in Vaughan?',
    answer: 'Vaughan residents can access our private mortgages, second mortgages, debt consolidation loans, and commercial mortgages.'
  }, {
    question: 'Do I need a credit check for a mortgage in Vaughan?',
    answer: "No, we do not perform credit checks. Your Vaughan property's equity is what secures your loan."
  }, {
    question: 'How quickly can I get funded in Vaughan?',
    answer: 'We offer rapid funding, often within 48 hours of approval for our Vaughan clients.'
  }, {
    question: 'What is the maximum I can borrow against my Vaughan home?',
    answer: 'You can borrow up to 80% of the appraised value of your home in Vaughan.'
  }, {
    question: "Can I get a mortgage in Vaughan if I'm self-employed?",
    answer: 'Yes, our no-income mortgages are ideal for self-employed professionals living in Vaughan.'
  }]
}, {
  slug: 'richmond-hill',
  name: 'Richmond Hill',
  heroDescription: 'Access the equity in your Richmond Hill home with ease. Our private mortgage solutions offer fast funding without the need for credit checks or income verification.',
  whyChooseDescription: 'Richmond Hill homeowners trust us for our transparent, equity-focused approach. We provide tailored mortgage solutions that leverage the strong property values in the Richmond Hill area.',
  reviews: [{
    id: 1,
    name: 'Kevin Y.',
    timeAgo: '1 week ago',
    text: "Getting a home equity loan in Richmond Hill was incredibly fast with EquityRich. They didn't care about my credit score, just the value of my home."
  }, {
    id: 2,
    name: 'Samantha L.',
    timeAgo: '2 months ago',
    text: 'I used EquityRich for a spousal buyout mortgage in Richmond Hill. They made a stressful situation much easier to handle with their quick approval.'
  }, {
    id: 3,
    name: 'David W.',
    timeAgo: '4 months ago',
    text: 'Great experience getting a second mortgage for my Richmond Hill property. The rates were fair and the service was exceptional.'
  }],
  faqs: [{
    question: 'What types of mortgages are available in Richmond Hill?',
    answer: 'We provide a full range of services in Richmond Hill, including home equity loans, second mortgages, and spousal buyout mortgages.'
  }, {
    question: 'Do I need a credit check for a mortgage in Richmond Hill?',
    answer: 'No credit check is required. We base our approvals on the equity available in your Richmond Hill property.'
  }, {
    question: 'How quickly can I get funded in Richmond Hill?',
    answer: 'Richmond Hill homeowners can typically access their funds within 48 hours of approval.'
  }, {
    question: 'What is the maximum I can borrow against my Richmond Hill home?',
    answer: "You can access up to 80% of your Richmond Hill home's appraised value."
  }, {
    question: "Can I get a mortgage in Richmond Hill if I'm self-employed?",
    answer: 'Yes, we offer flexible solutions for self-employed individuals in Richmond Hill without requiring traditional income proof.'
  }]
}, {
  slug: 'oakville',
  name: 'Oakville',
  heroDescription: 'Unlock the financial potential of your Oakville property. We offer premium, equity-based mortgage solutions with fast approvals and no credit requirements.',
  whyChooseDescription: 'We provide Oakville homeowners with discrete, professional, and fast private lending services. Our equity-based model ensures you can access your wealth without the rigid constraints of traditional banking.',
  reviews: [{
    id: 1,
    name: 'Richard H.',
    timeAgo: '2 weeks ago',
    text: 'EquityRich helped me secure a bridge mortgage for my new Oakville home. The process was smooth and allowed me to buy before selling my old place.'
  }, {
    id: 2,
    name: 'Caroline T.',
    timeAgo: '1 month ago',
    text: 'I wanted to access equity from my Oakville property for an investment opportunity. EquityRich provided the funds in 48 hours without any income checks.'
  }, {
    id: 3,
    name: 'Paul M.',
    timeAgo: '3 months ago',
    text: 'The team provided excellent service when I needed a HELOC on my Oakville home. Very professional and transparent about all costs.'
  }],
  faqs: [{
    question: 'What types of mortgages are available in Oakville?',
    answer: 'Oakville residents can utilize our private mortgages, bridge loans, HELOCs, and property investment mortgages.'
  }, {
    question: 'Do I need a credit check for a mortgage in Oakville?',
    answer: 'No, our lending in Oakville is strictly equity-based, meaning no credit checks are required.'
  }, {
    question: 'How quickly can I get funded in Oakville?',
    answer: 'We offer expedited funding for Oakville properties, often within 48 hours.'
  }, {
    question: 'What is the maximum I can borrow against my Oakville home?',
    answer: "Oakville homeowners can borrow up to 80% of their property's appraised value."
  }, {
    question: "Can I get a mortgage in Oakville if I'm self-employed?",
    answer: 'Absolutely. Our no-income-verification loans are perfect for self-employed Oakville residents.'
  }]
}, {
  slug: 'burlington',
  name: 'Burlington',
  heroDescription: "Leverage your Burlington home's equity for the funds you need today. Fast, flexible private mortgages with no credit checks or income verification required.",
  whyChooseDescription: "Serving the Burlington area, we specialize in helping homeowners unlock their property's value. Our streamlined, equity-focused approach means you get the funds you need faster and with less hassle.",
  reviews: [{
    id: 1,
    name: 'Jessica B.',
    timeAgo: '1 week ago',
    text: "I used EquityRich to consolidate debt using my Burlington home's equity. It lowered my monthly payments significantly and the process was so easy."
  }, {
    id: 2,
    name: 'Mark D.',
    timeAgo: '2 months ago',
    text: "Getting a second mortgage in Burlington was fast and painless with EquityRich. They didn't require any income verification, which was perfect for my situation."
  }, {
    id: 3,
    name: 'Susan P.',
    timeAgo: '5 months ago',
    text: 'EquityRich provided a reverse mortgage for my Burlington home, allowing me to enjoy my retirement without monthly mortgage payments. Highly recommended!'
  }],
  faqs: [{
    question: 'What types of mortgages are available in Burlington?',
    answer: 'We offer debt consolidation mortgages, second mortgages, reverse mortgages, and more for Burlington homeowners.'
  }, {
    question: 'Do I need a credit check for a mortgage in Burlington?',
    answer: 'No credit check is needed. We approve loans based on the equity in your Burlington home.'
  }, {
    question: 'How quickly can I get funded in Burlington?',
    answer: 'Burlington clients can typically receive their funds within 48 hours of approval.'
  }, {
    question: 'What is the maximum I can borrow against my Burlington home?',
    answer: 'You can access up to 80% of the appraised value of your Burlington property.'
  }, {
    question: "Can I get a mortgage in Burlington if I'm self-employed?",
    answer: 'Yes, our alternative lending solutions in Burlington do not require traditional proof of income.'
  }]
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function LocationDetailPage() {
  const {
    locationSlug
  } = useParams<{
    locationSlug: string;
  }>();
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const location = locationsData.find(loc => loc.slug === locationSlug);
  if (!location) {
    return <main className="w-full min-h-[60vh] flex flex-col items-center justify-center bg-cream px-4" data-id="element-747">
        <h1 className="text-4xl font-serif text-gray-900 mb-4" data-id="element-748">
          Location Not Found
        </h1>
        <p className="text-gray-600 mb-8" data-id="element-749">
          We couldn't find the location you're looking for.
        </p>
        <Button variant="primary" href="/locations" data-id="element-750">
          View All Locations
        </Button>
      </main>;
  }
  const IllustrationComponent = locationIllustrations[location.slug] || TorontoIllustration;
  const services = [{
    name: `Private Mortgages in ${location.name}`,
    slug: 'private-mortgages',
    desc: `Access funds quickly based on your ${location.name} home's equity, not your credit score.`
  }, {
    name: `Home Equity Loans in ${location.name}`,
    slug: 'home-equity-loans',
    desc: `Get a lump sum of cash by leveraging the value you've built in your ${location.name} property.`
  }, {
    name: `Second Mortgages in ${location.name}`,
    slug: 'second-mortgages',
    desc: `Keep your first mortgage intact while accessing additional funds from your ${location.name} home.`
  }, {
    name: `Reverse Mortgages in ${location.name}`,
    slug: 'reverse-mortgages',
    desc: `Access tax-free cash with no monthly payments required for ${location.name} homeowners 55+.`
  }, {
    name: `Debt Consolidation in ${location.name}`,
    slug: 'debt-consolidation-mortgage',
    desc: `Combine high-interest debts into one lower monthly payment using your ${location.name} home's equity.`
  }, {
    name: `HELOC in ${location.name}`,
    slug: 'heloc',
    desc: `Get a flexible revolving line of credit secured against your ${location.name} property.`
  }];
  return <main className="w-full" data-id="element-751">
      {/* Section 1: Hero */}
      <section className="w-full relative overflow-hidden bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-752">
        {/* Radial gold glow */}
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 50% 70% at 10% 60%, rgba(201,169,97,0.12) 0%, rgba(201,169,97,0.04) 40%, transparent 70%)'
      }} aria-hidden="true" data-id="element-753" />

        <div className="max-w-7xl mx-auto relative z-10" data-id="element-754">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-755">
            {/* Left: Text content */}
            <div data-id="element-756">
              <Link to="/locations" className="inline-flex items-center text-sm text-white/70 hover:text-white transition-colors mb-8 font-medium" data-id="element-757">
                <ArrowLeftIcon className="h-4 w-4 mr-1.5" aria-hidden="true" data-id="element-758" />
                All Locations
              </Link>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white font-[500] leading-tight mb-6" data-id="element-759">
                Home Equity Mortgage Solutions in {location.name}
              </h1>
              <p className="text-lg md:text-xl text-gray-300 max-w-xl leading-relaxed mb-8" data-id="element-760">
                {location.heroDescription}
              </p>
              <Button variant="primary" size="lg" href="/contact" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-761">
                Get Your Free Assessment
              </Button>
            </div>

            {/* Right: Location illustration */}
            <motion.div className="hidden lg:flex items-center justify-center" initial={{
            opacity: 0,
            x: 40
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: 0.2
          }} data-id="element-762">
              <div className="w-full max-w-[380px] aspect-square" data-id="element-763">
                <IllustrationComponent data-id="element-764" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 2: Why Choose Us */}
      <section className="w-full bg-cream py-20 px-4" data-id="element-765">
        <div className="max-w-7xl mx-auto" data-id="element-766">
          <div className="text-center mb-12" data-id="element-767">
            <span className="inline-block px-4 py-2 text-[12px] font-[Poppins,_sans-serif] text-[#07493a] bg-[#07493a1a] font-medium rounded-full mb-4 border border-primary/20 pt-[4px] pb-[4px] pl-[18px] pr-[18px]" data-id="element-768">
              WHY CHOOSE US
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 font-[500] mb-6" data-id="element-769">
              Why Choose EquityRich in {location.name}?
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-770">
              {location.whyChooseDescription}
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 max-w-5xl mx-auto" data-id="element-771">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-772">
              {['No credit check required', 'No income verification needed', 'Funding in as little as 48 hours', 'Up to 80% loan-to-value ratio', 'FSRA Licensed (#12755)', `Local expertise in ${location.name} real estate market`].map((bullet, idx) => <div key={idx} className="flex items-start" data-id="element-773">
                  <CheckCircleIcon className="h-6 w-6 text-primary mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-774" />
                  <span className="text-lg text-gray-800 font-medium" data-id="element-775">
                    {bullet}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Services */}
      <section className="w-full bg-white py-20 px-4" data-id="element-776">
        <div className="max-w-7xl mx-auto" data-id="element-777">
          <div className="text-center mb-16" data-id="element-778">
            <span className="inline-block px-4 py-2 text-[12px] font-[Poppins,_sans-serif] text-[#07493a] bg-[#07493a1a] font-medium rounded-full mb-4 border border-primary/20 pt-[4px] pb-[4px] pl-[18px] pr-[18px]" data-id="element-779">
              OUR SERVICES
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 font-[500]" data-id="element-780">
              Mortgage Services We Offer in {location.name}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-781">
            {services.map((service, idx) => <div key={idx} className="bg-white hover:bg-cream transition-colors duration-300 rounded-2xl shadow-sm p-8 border border-gray-100 flex flex-col h-full" data-id="element-782">
                <h3 className="text-xl font-serif text-gray-900 font-[500] mb-4" data-id="element-783">
                  {service.name}
                </h3>
                <p className="text-gray-600 mb-8 flex-1" data-id="element-784">{service.desc}</p>
                <Link to={`/services/${service.slug}`} className="inline-flex items-center text-primary font-medium hover:text-accent transition-colors mt-auto" data-id="element-785">
                  Learn More{' '}
                  <ArrowLeftIcon className="h-4 w-4 ml-2 rotate-180" aria-hidden="true" data-id="element-786" />
                </Link>
              </div>)}
          </div>
        </div>
      </section>

      {/* Section 4: Customer Reviews */}
      <section className="w-full bg-cream py-20 px-4 overflow-hidden" data-id="element-787">
        <div className="max-w-7xl mx-auto" data-id="element-788">
          <div className="text-center mb-16" data-id="element-789">
            <span className="inline-block px-4 py-2 text-[12px] font-[Poppins,_sans-serif] text-[#07493a] bg-[#07493a1a] font-medium rounded-full mb-4 border border-primary/20 pt-[4px] pb-[4px] pl-[18px] pr-[18px]" data-id="element-790">
              CLIENT REVIEWS
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 font-[500] mb-6" data-id="element-791">
              What {location.name} Homeowners Say About Us
            </h2>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4" data-id="element-792">
              <div className="flex items-center gap-2" data-id="element-793">
                <span className="text-3xl font-bold text-gray-900" data-id="element-794">4.9</span>
                <div className="flex text-[#FBBC05]" data-id="element-795">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-796" />)}
                </div>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-797"></div>
              <div className="flex items-center gap-2" data-id="element-798">
                <svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" data-id="element-799">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-800" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-801" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-802" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-803" />
                </svg>
                <span className="text-gray-600 font-medium" data-id="element-804">
                  Based on 150+ Google Reviews
                </span>
              </div>
            </div>
          </div>
          <motion.div className="grid grid-cols-1 lg:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} data-id="element-805">
            {location.reviews.map(review => <motion.div key={review.id} variants={cardVariants} className="bg-white rounded-2xl shadow-sm p-8 flex flex-col h-full" data-id="element-806">
                <div className="flex text-[#FBBC05] mb-6" data-id="element-807">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-808" />)}
                </div>
                <p className="text-gray-700 leading-relaxed mb-8 flex-1 italic" data-id="element-809">
                  "{review.text}"
                </p>
                <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100" data-id="element-810">
                  <div data-id="element-811">
                    <h4 className="font-bold text-gray-900" data-id="element-812">{review.name}</h4>
                    <span className="text-sm text-gray-500" data-id="element-813">
                      {review.timeAgo}
                    </span>
                  </div>
                  <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" className="opacity-80" data-id="element-814">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-815" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-816" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-817" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-818" />
                  </svg>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* Section 5: Location FAQ */}
      <section className="w-full bg-white py-20 px-4" data-id="element-819">
        <div className="max-w-4xl mx-auto" data-id="element-820">
          <div className="text-center mb-16" data-id="element-821">
            <span className="inline-block px-4 py-2 text-[12px] font-[Poppins,_sans-serif] text-[#07493a] bg-[#07493a1a] font-medium rounded-full mb-4 border border-primary/20 pt-[4px] pb-[4px] pl-[18px] pr-[18px]" data-id="element-822">
              COMMON QUESTIONS
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 font-[500] mb-4" data-id="element-823">
              Frequently Asked Questions About Mortgages in {location.name}
            </h2>
          </div>
          <div className="space-y-4" data-id="element-824">
            {location.faqs.map((faq, index) => <div key={index} className="bg-cream rounded-xl shadow-sm overflow-hidden border border-gray-100" data-id="element-825">
                <button onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" aria-expanded={openFaqIndex === index} data-id="element-826">
                  <span className="text-lg font-semibold text-gray-900 pr-8" data-id="element-827">
                    {faq.question}
                  </span>
                  <div className="flex-shrink-0 w-10 h-10 bg-primary rounded-lg flex items-center justify-center" data-id="element-828">
                    {openFaqIndex === index ? <MinusIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-829" /> : <PlusIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-830" />}
                  </div>
                </button>
                {openFaqIndex === index && <div className="px-6 pb-6" data-id="element-831">
                    <div className="pt-2 border-t border-gray-200" data-id="element-832">
                      <p className="text-gray-700 leading-relaxed mt-4" data-id="element-833">
                        {faq.answer}
                      </p>
                    </div>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Section 6: Bottom CTA */}
      <section className="w-full relative overflow-hidden bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-834">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 60% 80% at 80% 20%, rgba(201,169,97,0.15) 0%, rgba(201,169,97,0.06) 40%, transparent 70%)'
      }} aria-hidden="true" data-id="element-835" />
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-836">
          <h2 className="text-3xl md:text-4xl font-serif text-white font-[500] mb-6" data-id="element-837">
            Ready to Unlock Your Home Equity in {location.name}?
          </h2>
          <p className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto" data-id="element-838">
            No credit check. No income verification. Our local {location.name}{' '}
            team is ready to help you access the funds you need.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-839">
            <Button variant="primary" size="lg" icon href="/contact" className="bg-accent hover:bg-accent-dark text-white border-none w-full sm:w-auto justify-center" data-id="element-840">
              Get My Free Assessment
            </Button>
            <a href="/calculator" className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium border-2 border-white text-white hover:bg-white hover:text-primary rounded-xl transition-all w-full sm:w-auto" data-id="element-841">
              Try Our Calculator
            </a>
          </div>
        </div>
      </section>
    </main>;
}